import compact from "lodash/compact";
import { useMemo } from "react";

import {
  isConversationSupportConversation as isConversationModelSupportConversation,
  getConversationToken as getConversationModelToken,
} from "./ConversationModel";
import { FILTER_SUPPORT_CONVERSATION } from "./MainStreamFetchState";
import { useMessengerContext } from "./MessengerContext";
import { useMessengerStoreAllOrderedConversations } from "./useMessengerStoreAllOrderedConversations";
import { useMessengerStoreMainStreamFetchState } from "./useMessengerStoreMainStreamFetchState";

export const useMessengerStoreOrderedConversations = () => {
  const { searchResults, hiddenConversations } = useMessengerContext() ?? {};
  const { mainStreamFetchState } = useMessengerStoreMainStreamFetchState();
  const { allOrderedConversations } =
    useMessengerStoreAllOrderedConversations();

  const orderedConversations = useMemo(() => {
    if (!mainStreamFetchState) {
      return [];
    }
    // TEST(Ian): search results are used when search or context token exists
    let _orderedConversations = allOrderedConversations;
    if (searchResults) {
      _orderedConversations = compact(
        Array.from(searchResults.values()).map((token) =>
          mainStreamFetchState.conversationByUserToken.get(token)
        )
      );
    }

    //filtering out support conversations as well as the staging Olivia conversation that causes issues
    _orderedConversations = FILTER_SUPPORT_CONVERSATION
      ? _orderedConversations.filter(
          (item) =>
            !isConversationModelSupportConversation(item) &&
            item.otherParty?.token !== "u_eafa228a"
        )
      : _orderedConversations;

    // Filtering out conversations hidden by user when they mark it as spam
    _orderedConversations = _orderedConversations.filter(
      (conversation) =>
        !hiddenConversations?.includes(getConversationModelToken(conversation))
    );
    return _orderedConversations;
  }, [
    hiddenConversations,
    allOrderedConversations,
    mainStreamFetchState,
    searchResults,
  ]);

  return useMemo(() => ({ orderedConversations }), [orderedConversations]);
};
